import { ContentChunkFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import OptimizedImage from '@/ui/components/shared/OptimizedImage';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import React from 'react';

export default function NonCompatibleScreen({ chunk }: { chunk: ContentChunkFragment }) {
  const helpScreenChunk = chunk.chunks?.[0];
  const title = extractComponentFromChunk(helpScreenChunk, 'title', 'SingleLineContent')?.text;
  const description = extractComponentFromChunk(helpScreenChunk, 'description', 'RichTextContent');
  return (
    <div>
      <h2 className="mb-2 text-2xl font-bold">{title}</h2>
      <RichTextRenderer blocks={description} />
    </div>
  );
}
